import NotificationCard from "@/components/notifications/NotificationCard"
import GraphError from "@/components/util/error/GraphError"
import Loading from "@/components/util/Loading"
import { gql, useMutation, useQuery } from "@apollo/client"
import { Grid, makeStyles, Typography } from "@material-ui/core"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { ClearNotifications } from "./__generated__/ClearNotifications"
import { Notifications as NotificationsType } from "./__generated__/Notifications"

export const GET_NOTIFICATIONS = gql`
  query Notifications {
    me {
      id
      notifications(first: 100) {
        data {
          id
          created_at
          read_at
          data
        }
      }
    }
  }
`

export const CLEAR_NOTIFICATIONS = gql`
  mutation ClearNotifications {
    clearNotifications {
      id
      notificationsUnreadCount
    }
  }
`

const useStyles = makeStyles(theme => ({
  header: {
    margin: theme.spacing(2)
  }
}))

export default function Notifications() {
  const { t } = useTranslation()
  const classes = useStyles()

  const { loading, error, data } =
    useQuery<NotificationsType>(GET_NOTIFICATIONS)
  const [clearNotifications] =
    useMutation<ClearNotifications>(CLEAR_NOTIFICATIONS)

  useEffect(() => {
    clearNotifications()
  }, [clearNotifications])

  if (loading) return <Loading />
  if (error) return <GraphError error={error} />

  if (!data) return null

  const notifications = data?.me?.notifications?.data

  return (
    <Grid container direction="row" justifyContent="center">
      <Grid item md={6}>
        <Grid container spacing={2}>
          {notifications?.length === 0 ? (
            <Typography variant="h6" className={classes.header}>
              {t("No Notifications")}
            </Typography>
          ) : (
            notifications?.map((notification, index) => (
              <Grid item xs={12} key={index}>
                <NotificationCard notification={notification} />
              </Grid>
            ))
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}
